// The `files` pack (2026-10-31, docs/areas/files.md): the File kind and the
// Files app, the owner's own Dropbox (the bytes in an S3 bucket, the metadata
// synced). Life (the AlfieOS suite's manifest) lists it; any other suite turns
// it on in its editor (Settings → Suites).
import { FolderOpen } from 'lucide-react'
import { registerPack } from './index'
import { fileKind } from '@/kinds/file'

export const filesPack = registerPack({
  name: 'files',
  title: 'Files',
  description: 'your own storage: upload, look at almost anything in the browser, share with a link',
  kinds: [fileKind],
  nav: [{ to: '/files', label: 'Files', icon: '📁', Icon: FolderOpen, key: 'f' }],
  layout: { section: 'organise' },
})
